/**
 * Config shape for the "Import Event from Plan" modal on the Calendar page.
 */

/** Which related-plan bucket the source plan is picked from. Keys of `sourceLabels`. */
export type ImportEventSourceCategory = 'self' | 'parent' | 'child';

/** Which plan universe the source-plan list is drawn from, per the TPM/TPO switch. */
export type ImportEventPlanType = 'tpm' | 'tpo';

/** Side the TPM/TPO switch starts on when a config omits `defaultPlanType`. */
export const DEFAULT_IMPORT_EVENT_PLAN_TYPE: ImportEventPlanType = 'tpm';

/** How to render a column's cell value. */
export type ImportEventColumnRenderAs = 'text' | 'startCase' | 'upperCase' | 'date' | 'configLabel';

/** Comparison strategy used to sort a column. */
export type ImportEventColumnSortBy = 'text' | 'date';

export interface ImportEventTableColumnConfig {
    key: string;
    title: string;  // Column header label.
    dataIndex: string;  // Dot-notation path on the `ImportableEventRow` object.
    width?: number;  // Optional fixed pixel width.
    ellipsis?: boolean;  // Truncate overflowing cell text with an ellipsis. Defaults to `true`.
    renderAs?: ImportEventColumnRenderAs;  // Cell render strategy. Defaults to `'text'` (plain value, no transform).
    /** Key in `fieldValueLabelMaps` used when `renderAs` is `'configLabel'`. */
    resolveLabelFrom?: string;
    sortBy?: ImportEventColumnSortBy;  // Comparison strategy used to sort a column.
    sortDirections?: ('ascend' | 'descend')[];
}

export interface ImportEventFromPlanConfig {
    modalTitle: string;
    modalWidth?: number;
    /** Side the TPM/TPO switch opens on, and returns to on reset. Defaults to `DEFAULT_IMPORT_EVENT_PLAN_TYPE`. */
    defaultPlanType?: ImportEventPlanType;
    sourceLabels: Record<string, string>;   // Display labels for each source-category radio button, keyed by category id.
    tableColumns: ImportEventTableColumnConfig[];
}